import requests from "./httpServices";

// Get current user's identity for VB ownership
const getVbUserId = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?._id) return user._id;
  } catch {}
  // Guest fallback — stable per browser tab
  let id = sessionStorage.getItem("vb-guest-session-id");
  if (!id) {
    id = `guest_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem("vb-guest-session-id", id);
  }
  return id;
};

export const uploadVirtualBackground = (file, roomId) => {
  const formData = new FormData();
  formData.append("background", file);
  formData.append("roomId", roomId);
  formData.append("uploaderId", getVbUserId());

  return requests.post("/virtual-backgrounds/upload", formData);
};

export const getRoomVirtualBackgrounds = () => {
  const uid = getVbUserId();
  return requests.get(`/virtual-backgrounds/room/all?uploaderId=${encodeURIComponent(uid)}`);
};

export const deleteVirtualBackground = (id) => {
  const uid = getVbUserId();
  return requests.delete(`/virtual-backgrounds/${id}?uploaderId=${encodeURIComponent(uid)}`);
};

export const getVirtualBackgroundPreference = (roomId) => {
  const uid = getVbUserId();
  return requests.get(
    `/virtual-backgrounds/preference?roomId=${encodeURIComponent(roomId)}&userId=${encodeURIComponent(uid)}`
  );
};

export const saveVirtualBackgroundPreference = (roomId, preference) => {
  const uid = getVbUserId();
  return requests.post(`/virtual-backgrounds/preference`, {
    userId: uid,
    roomId,
    type: preference.type,
    imageUrl: preference.imageUrl || null,
    blurStrength: preference.blurStrength ?? 50,
  });
};
